import { useMemo } from 'react'

const COLORS = [
  '#FFD700', '#FF6B6B', '#4ECDC4', '#45B7D1',
  '#96CEB4', '#FF99C8', '#C9B1FF', '#FFA07A',
]

interface Piece {
  left: string
  width: string
  height: string
  backgroundColor: string
  animationDuration: string
  animationDelay: string
  borderRadius: string
  transform: string
}

export default function Confetti() {
  const pieces = useMemo<Piece[]>(
    () =>
      Array.from({ length: 70 }, () => ({
        left:              `${Math.random() * 100}%`,
        width:             `${5 + Math.random() * 6}px`,
        height:            `${8 + Math.random() * 10}px`,
        backgroundColor:   COLORS[Math.floor(Math.random() * COLORS.length)],
        animationDuration: `${2.5 + Math.random() * 3}s`,
        animationDelay:    `${Math.random() * 2}s`,
        borderRadius:      Math.random() > 0.5 ? '50%' : '2px',
        transform:         `rotate(${Math.floor(Math.random() * 360)}deg)`,
      })),
    [],
  )

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-40">
      {pieces.map((style, i) => (
        <div
          key={i}
          className="absolute top-0"
          style={{
            ...style,
            animation: `confettiFall ${style.animationDuration} ${style.animationDelay} linear forwards`,
          }}
        />
      ))}
    </div>
  )
}
